module.exports = __webpack_public_path__ + "images/valentin-82e38bc9d57ca87aa320cf9a77ce1d9c.jpg";